module.exports = __webpack_public_path__ + "static/mahatma-gandhi-4f13bbfdc249b64d7e724832fb0dc86c.jpg";